import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as docketActions from '../../../../redux/actions/docketActions';
import { hasValidClientCode } from '../../../../redux/actions/clientCodeAction';
import EmailAttachmentPurchaseForm from './EmailAttachmentPurchaseForm';
import EmailForm from './EmailForm';
import './DocketPopup.less';

export class EmailBulkModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSendEmail: false,
      email_addresses: '',
      email_message: '',
    };
  }

  componentDidMount() {
    // On open, begin docket part inspection process
    this.props.dispatch(docketActions.getDocketParts(this.props.popup.data));
  }

  componentDidUpdate(prevProps) {
    // Nudge along in case no buying necessary
    // This should really be triggered by action and not state transition
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.enableEmailForm();
    }
  }

  onSendEmail = ({ emails, message }) => {
    this.setState(
      {
        canSendEmail: false,
        email_addresses: emails,
        email_message: message,
      },
      () => {
        this.emailPdfsZip();
      }
    );
  };

  onClose = () => {
    this.setState({ canSendEmail: false });
    this.props.onClose();
  };

  getParams = () => {
    const { email_addresses, email_message } = this.state;
    return {
      ...this.props.popup.data,
      email_addresses,
      email_message,
    };
  };

  buy = () => {
    if (this.props.dispatch(hasValidClientCode())) {
      this.props.dispatch(docketActions.buyAllParts(this.getParams())).then(() => this.enableEmailForm());
    } else {
      this.props.onClose();
    }
  };

  enableEmailForm() {
    this.setState({ canSendEmail: true });
  }

  emailPdfsZip = () => {
    this.props
      .dispatch(docketActions[this.props.emailActionName](this.getParams()))
      // .then(this.props.reloadDetails)
      .then(() => {
        this.setState({ canSendEmail: false });
      });
  };

  render() {
    const { docketParts, selectedDocket, popup, entries, emailActionName } = this.props;

    return (
      <Modal show onHide={this.onClose} backdrop="static" className="docket-popup">
        <Modal.Header closeButton>
          <Modal.Title>{this.props.topBarTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EmailForm
            canSend={this.state.canSendEmail}
            onSendEmail={this.onSendEmail}
            onCancel={this.onClose}
            sendButtonHint="Purchase documents, fill out destination address and any message and then click `Send`"
          >
            {
              <div className="docket-info-section">
                {popup.data.docket && (
                  <div>
                    <span>
                      {`${popup.data.docket.date_filed} | ${popup.data.docket.docket_no} | ${popup.data.docket.docket_text}`}
                    </span>
                  </div>
                )}
                <div className="docket-number-link">
                  <a href={`/filings/${popup.data.case_uuid}`}>{popup.data.case_number}</a>
                </div>
              </div>
            }
            <label style={{ marginTop: '8px' }}>
              <i className="fa fa-paperclip" /> Attachment
            </label>
            <div className="bg-color-grey">
              <EmailAttachmentPurchaseForm
                hidePendingSteps
                docketParts={docketParts}
                buy={this.buy}
                selectedDocket={selectedDocket}
                entries={entries}
                emailActionName={emailActionName}
              />
            </div>
          </EmailForm>
        </Modal.Body>
      </Modal>
    );
  }
}

EmailBulkModal.propTypes = {
  topBarTitle: PropTypes.string.isRequired,
  emailActionName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  entries: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { popup, docketParts, selectedDocket, entries } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    selectedDocket,
    entries,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailBulkModal);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailBulkModal.jsx